(function(){
     'use strict';

     angular
        .module('appback')
        .factory('ProtesService', ProtesService);

    ProtesService.$inject = ['$http'];

    function ProtesService($http){


        var service= {
           getProtesSec:getProtesSec,
           guardarStric:guardarStric,
           guardarInfoSec : guardarInfoSec
        };

        return service;
        function getProtesSec(buscador,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/proteinograma/getprotessec', { params : { buscador:buscador }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }


        function guardarInfoSec(item,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                item:JSON.stringify(item) 
            });
            $http.post('/backend/proteinograma/guardarinfosec',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function guardarStric(protes,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/proteinograma/guardarstric', { params : { protes : JSON.stringify(protes) }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

    }
})();